import { SpAlert } from '../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor($uibModal, $state, Alert, SaaspassConnectService) {
        // this.$uibModal = $uibModal;
        this.SaaspassConnectService = SaaspassConnectService;
        this.Alert = Alert;
        this.$state = $state;
    }

    $onInit() {
    }

    addNewSaaspassConnectApp() {
        //this.$uibModal.open({component: 'addSaaspassConnect'});
        this.SaaspassConnectService.saaspassConnects
          .save({id:this.$state.params.companyId}, null).$promise
          .then((data) =>  {
          	this.$state.go('company.saaspass-connect.manage', {connectId: data.id}, {reload: 'company.saaspass-connect'});
            this.Alert('success', 'saaspass_connect.create_success');
          })
          .catch((error) => this.spAlert = new SpAlert('danger', error.data.message));
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/saaspass-connect.controller.js